import { render, staticRenderFns } from "./CreateActMirror.vue?vue&type=template&id=cba3c094&scoped=true&"
import script from "./CreateActMirror.vue?vue&type=script&lang=js&"
export * from "./CreateActMirror.vue?vue&type=script&lang=js&"
import style0 from "./CreateActMirror.vue?vue&type=style&index=0&id=cba3c094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba3c094",
  null
  
)

export default component.exports